import { clsx } from 'clsx';
import { VisuallyHidden } from '@/components/ui/VisuallyHidden';
import { useFormatters, useT } from '@/lib/i18n';

export interface DiscountBadgeProps {
  /** Whole percent off (from the API's `price.discount.percentOff`). Nothing renders at 0. */
  percentOff: number;
  className?: string;
}

/** `−15%` in brass. Screen readers hear "15 percent off" instead of a minus sign. */
export function DiscountBadge({ percentOff, className }: DiscountBadgeProps) {
  const t = useT();
  const { formatNumber } = useFormatters();
  if (percentOff <= 0) return null;
  return (
    <span className={clsx('badge badge--discount', className)}>
      <span aria-hidden="true">−{formatNumber(percentOff)}%</span>
      <VisuallyHidden>{t('price.offSr', { percent: formatNumber(percentOff) })}</VisuallyHidden>
    </span>
  );
}
